<script>
export default {
  name: "App",
  data() {
    return {
    };
  },
  components: {},
  methods: {
    login() {
      console.log("aaaaaaaaaaaaaaaaaaaaaa");
      const GoogleUser = this.$gAuth.signIn();
      console.log("GoogleUser", this.$gAuth.signIn());
    },
  },
};
</script>

<template>
  <div class="mt-17 text-center">
    <h1 class="text-center bold dark_blue">Google login</h1>
    <button type="button" class="float-right col-lg-6 col-6" @click="login()">
      <img
        class="soicail_img"
        src="/images/login_contact/Linkedin.svg"
        alt=""
      />
    </button>
  </div>
</template>
